module.exports = __webpack_public_path__ + "static/img/ewm3.491a994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ewm3.png
// module id = 6KS4
// module chunks = 1